export const browserStorageKey = {
  ACCESS_TOKEN: 'academyAccessToken',
};
